window.addEventListener('DOMContentLoaded', function () {
  // #page-topをクリックした際の設定
  $('#pagetop').click(function () {
    $('body,html').animate({
      scrollTop: 0//ページトップまでスクロール
    }, 500);//ページトップスクロールの速さ。数字が大きいほど遅くなる
    return false;//リンク自体の無効化
  });


  const headerH  = $("sticky-header").height()+'px';
  if(window.innerWidth < 750){
    $("#MainContent").css("margin-top", headerH);
  }

    var headerHeight = $("#shopify-section-header header").height();
    $('a[href^="#"]').click(function () {
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? "html" : href);

      
      if(window.innerWidth < 750 ){
        var position = target.offset().top - headerHeight;
      }else{
        var position = target.offset().top;

      }

      
      

      //var position = target.offset().top;
    
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    });

 
});


